// extracted by mini-css-extract-plugin
module.exports = {"vacancyBlock":"styles-styles-module--vacancyBlock--1aokY"};